module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av119-f0714ac45355b5375a608548d429baa2.jpg";